import { useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import FormEditorExternal from 'modules/forms/components/editor/externalEditor/FormEditorExternal'

const EditTemplateQuestions = () => {
  const { navigation } = useNavigation()
  const { templateId } = useParams()
  return (
    <FormEditorExternal
      formId={String(templateId)}
      resourceType="Trainings::Training"
      navigateBack={navigation.trainings.list.surveyTemplates.templateDetails.questions.fullPath({
        templateId: String(templateId),
      })}
      emptyStateText={{
        title: i18n.t('forms.editor.empty_state.surveys.title'),
        description: i18n.t('forms.editor.empty_state.surveys.description'),
        buttonLabel: i18n.t('forms.editor.empty_state.surveys.button'),
      }}
    />
  )
}
export default EditTemplateQuestions
